<template>
    <div v-if="isLoading" class="loading-overlay"><p>Carregando dados...</p></div>
    <div v-if="msgAlerta" class="info-alert row-space"><span class="text">{{ msgAlerta }}</span></div>

    <div class="form-edit-page">
        <div class="row-start row-space">
            <div class="form-item-char20">
                <label class="label-caption">Ordem</label>
                <input type="text" class="input-right" v-model="objEdicao.ordem" maxlength="3" v-number />
            </div>
            
            <div class="form-item-char30">
                <label class="label-caption">Código (PAC)</label>
                <input type="text" v-model="objEdicao.codigo" maxlength="50" v-uppercase />
            </div>
        </div>


        <div class="row row-space">
            <div class="form-item">
                <label class="label-caption">Título</label>
                <textarea v-model="objEdicao.titulo" maxlength="250" rows="2" style="resize: none;"/>
            </div>
        </div>


        <div class="row-end">
            <label for="ativo">Cadastro ativo</label>
            <input type="checkbox" class="input-checkbox" id="ativo" v-model="objEdicao.ativo" true-value="S" false-value="N" />
        </div>

        <div class="row-end">
            <label for="ckagua">Coletar dados de água</label>
            <input type="checkbox" class="input-checkbox" id="ckagua" v-model="objEdicao.ckagua" true-value="S" false-value="N" />
        </div>

        <div class="row-end">
            <label for="ckfraude">Coletar dados de combate a fraude</label>
            <input type="checkbox" class="input-checkbox" id="ckfraude" v-model="objEdicao.ckfraude" true-value="S" false-value="N" />
        </div>

        <div class="row-end">
            <label for="cklux">Coletar dados de lux</label>
            <input type="checkbox" class="input-checkbox" id="cklux" v-model="objEdicao.cklux" true-value="S" false-value="N" />
        </div>

        <div class="row-end">
            <label for="cktemperaturas">Coletar dados de temperaturas</label>
            <input type="checkbox" class="input-checkbox" id="cktemperaturas" v-model="objEdicao.cktemperaturas" true-value="S" false-value="N" />
        </div>


        <div class="row-end">
            <button type="button" class="btn-confirm" @click="salvarDados">Salvar</button>
            <button type="button" class="btn-cancel" @click="closeForm">Cancelar</button>
        </div>
    </div>
</template>
  
<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { criarPac } from '@/models/pac';
import { globalStore } from '@/globals';

const emit = defineEmits(['close', 'save']);
const props = defineProps({idEdicao: {type: Number, default: 0}});

const isLoading = ref(false);
const msgAlerta = ref(null);
const objEdicao = ref(criarPac());


function closeForm() {emit('close');}


async function lerDados() {
    try{
        isLoading.value = true;
        msgAlerta.value = null;
        if (props.idEdicao > 0) {
            try{
                const req = await Api.getCadastroById('pac', props.idEdicao);
                Object.assign(objEdicao.value, req[0]);
            }catch (error){msgAlerta.value = error}
        }else{
            objEdicao.value.idep        = globalStore.idep;
        }
        objEdicao.value.idlogin         = globalStore.idlogin;
    } catch (error) {msgAlerta.value = error;
    }finally{isLoading.value=false;}
}


async function salvarDados() {
    msgAlerta.value = salvarDadosDadosOK();
    if (msgAlerta.value) return;

    try {
        isLoading.value = true;
        const response = await Api.genericPut('/cad/pac', objEdicao.value);
        if (response.bolok === 1){
            emit('save');
            emit('close');
        }else{
            msgAlerta.value = response.erro;
        }
    } catch (error){msgAlerta.value = `ATENÇÃO: ${error.message}`;
    } finally{isLoading.value=false;}
}


function salvarDadosDadosOK(){
    let x = '';
    
    if (objEdicao.value.ordem < 1) x += '\n-Informe a "Ordem" do PAC';
    if (!objEdicao.value.codigo) x += '\n-Informe o "Código" do PAC';
    if (!objEdicao.value.titulo) x += '\n-Informe o "Título" do PAC';

    if (x) return `Verifique os dados informados: ${x}`;
    return null;
}


onMounted(lerDados)
</script>